import { createReducer, on } from '@ngrx/store';
import { EventSystemApiActions } from '../actions/event-system.actions';
import { systemAdapter } from '../adapters/event-system.adapter';

export const eventSystemReducer = createReducer(
    systemAdapter.getInitialState(),
    on(EventSystemApiActions.retrieveListOfEventSystems, (state, { eventSystems }) => ({
        ...systemAdapter.setAll(eventSystems,state)
    })),
    on(EventSystemApiActions.fetchSingleEventSystem, (state, { eventSystem }) => ({
        ...systemAdapter.upsertOne(eventSystem,state)
    }))
)